"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfDismissAlertDto = instanceOfDismissAlertDto;
exports.DismissAlertDtoFromJSON = DismissAlertDtoFromJSON;
exports.DismissAlertDtoFromJSONTyped = DismissAlertDtoFromJSONTyped;
exports.DismissAlertDtoToJSON = DismissAlertDtoToJSON;
exports.DismissAlertDtoToJSONTyped = DismissAlertDtoToJSONTyped;
const AlertType_1 = require("./AlertType");
/**
 * Check if a given object implements the DismissAlertDto interface.
 */
function instanceOfDismissAlertDto(value) {
    if (!('alertType' in value) || value['alertType'] === undefined)
        return false;
    return true;
}
function DismissAlertDtoFromJSON(json) {
    return DismissAlertDtoFromJSONTyped(json, false);
}
function DismissAlertDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'alertType': (0, AlertType_1.AlertTypeFromJSON)(json['alertType']),
    };
}
function DismissAlertDtoToJSON(json) {
    return DismissAlertDtoToJSONTyped(json, false);
}
function DismissAlertDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'alertType': (0, AlertType_1.AlertTypeToJSON)(value['alertType']),
    };
}
//# sourceMappingURL=DismissAlertDto.js.map